import AnchorLink from '../../../../../../../Buttons/ButtonLink/AnchorLink'
import './MenuContentLinks.scss'

const WEB_PORTAL_URL = `${process.env.REACT_APP_WEB_PORTAL_URL}`

const MenuContentLinks = () => {
    const site = localStorage.getItem('site')
    const lang = 'cz'
    return (
        <div className="menu-content-links d-flex">
            <div className="d-flex flex-column">
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'cenik'}`}>Ceník</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'gold-class'}`}>Gold Class</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'theatre-deluxe'}`}>Theatre Deluxe</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'obcerstveni'}`}>Občerstvení</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'darkove-poukazy'}`}>Dárkové poukázky</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'blog'}`}>Blog</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'kontakty'}`}>Kontakt</AnchorLink>
            </div>
            <div className="d-flex flex-column">
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'technologie-salu'}`}>Tehnologie sálu</AnchorLink>
                <AnchorLink href={'https://firmy.cinestar.cz/'}>Pro firmy</AnchorLink>
                <AnchorLink href={`${WEB_PORTAL_URL}${lang}/${site}/${'pro-skoly'}`}>Pro školy</AnchorLink>
                <AnchorLink href={`https://firmy.cinestar.cz/pronajem-salu`}>Pronájmy sálu</AnchorLink>
                <AnchorLink href={`https://firmy.cinestar.cz/cs/kinoreklama`}>Kinoreklama</AnchorLink>
                <AnchorLink href={`https://www.kinolidi.cz/`}>Kariéra</AnchorLink>
            </div>
        </div>
    )
}

export default MenuContentLinks
